/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetReplyChildsQuery } from '../../models/get-reply-childs-query';
import { GetReplyChildsQueryResult } from '../../models/get-reply-childs-query-result';

export interface ApiKpiReportsGetReplyChildsPost$Params {
      body?: GetReplyChildsQuery
}

export function apiKpiReportsGetReplyChildsPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsGetReplyChildsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReplyChildsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsGetReplyChildsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetReplyChildsQueryResult>;
    })
  );
}

apiKpiReportsGetReplyChildsPost.PATH = '/api/KPIReports/GetReplyChilds';
